import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from '@/modules/auth/context/AuthProvider'
import { AppRoutes } from '@/routes'
import { TooltipProvider } from '@/components/ui/tooltip'
import { Toaster } from '@/components/ui/sonner'
import { VersionWatcher } from '@/components/layout/VersionWatcher'
import { ThemeProvider } from '@/providers/ThemeProvider'

export const App = () => {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <TooltipProvider>
            <AppRoutes />
            <Toaster />
            <VersionWatcher />
          </TooltipProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  )
}
